import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { DialogHeader } from '../DialogHeader/DialogHeader';
import { ImageCarousel, type ImageCarouselProps } from '../ImageCarousel/ImageCarousel';

const DEFAULT_MEDIA_ITEM_ALT = 'Media item';

interface Props {
  open: boolean;
  selectedMedium: string;
  onClose: () => void;
  media: string[];
  placeholderSrc?: string;
  handleNavigate?: (src: string) => void;
  slotProps?: {
    closeButtonAriaLabel?: string;
    imageCarousel?: Pick<ImageCarouselProps, 'slotProps'>;
    mediaItemAlt?: string;
  };
  imageCount: number;
}

export const MediaDialog = (props: Props) => {
  const { onClose, open, media, imageCount, selectedMedium, handleNavigate, placeholderSrc, slotProps } = props;

  return (
    <Dialog onClose={onClose} open={open} fullWidth data-testid="image-dialog" fullScreen translate="no">
      <DialogHeader title="" onClose={onClose} closeButtonAriaLabel={slotProps?.closeButtonAriaLabel} />
      <DialogContent
        sx={{
          padding: 1,
        }}
      >
        <ImageCarousel
          photoEvidence={media}
          selectedMedia={selectedMedium}
          showActions
          showImageCounter={true}
          handleNavigate={handleNavigate}
          slotProps={{
            mediaItem: {
              alt: slotProps?.mediaItemAlt ?? DEFAULT_MEDIA_ITEM_ALT,
              objectFit: 'contain',
              placeholderSrc: placeholderSrc,
            },
            mediaItemSlot: slotProps?.imageCarousel?.slotProps?.mediaItemSlot,
            sidebar: slotProps?.imageCarousel?.slotProps?.sidebar,
          }}
          imageCount={imageCount}
        />
      </DialogContent>
    </Dialog>
  );
};
